import { mergeDeepRight } from 'ramda'
import { i18n } from '@/i18n'
import { getDimensions } from '@/utils'

import { VueComponentUpload as upload } from '@kvass/storage'

const preloadImages = result => {
  const files = result instanceof Array ? result : [result]
  return Promise.all(
    files.map(file => {
      if (!file || !file.type || !file.type.startsWith('image/')) return Promise.resolve()
      return getDimensions(file.url).catch(() => {})
    }),
  ).then(() => result)
}
import onFileDrop from '@/components/vendors/kvass-file/onDrop'
import onError from '@/components/vendors/vue-elder-loader/onError'
import MediaOnDrop from '@/components/vendors/kvass-media/onDrop'

import { setup as FileSetup } from '@kvass/file'
import { setup as ButtonSetup } from 'vue-elder-button'
import { setup as LoaderSetup } from 'vue-elder-loader'
import { setup as MediaSetup } from '@kvass/media'
import { setup as RichTextSetup } from '@kvass/rich-text/index.js'
import { setup as StepperSetup } from 'vue-elder-stepper'

export default () => {
  ButtonSetup({
    type: 'button',
    labels: {
      loading: i18n.t('loading', { resource: undefined }) + '...',
      error: i18n.t('somethingWentWrong'),
      confirm: i18n.t('areYouSure'),
      success: i18n.t('completed'),
    },
  })

  LoaderSetup({
    messages: {
      loading: i18n.t('loading', { resource: undefined }) + '...',
      error: onError,
    },
  })

  MediaSetup({
    upload: (rawFile, onProgress, options) =>
      upload(
        rawFile,
        onProgress,
        mergeDeepRight(
          {
            compression: 'gallery',
            transform: v => ({ ...v, tags: [], description: null, hash: null }),
          },
          options,
        ),
      ).then(preloadImages),
    dropMessage: MediaOnDrop,
    labels: {
      image: i18n.tc('image', 1),
      select: i18n.t('select'),
      cancel: i18n.t('cancel'),
      save: i18n.t('save'),
      descriptionPlaceholder: i18n.t('mediaDescriptionPlaceholder'),
      selectMessage: i18n.t('mediaTypeDefaultMessage'),
      tagsPlaceholder: `${i18n.t('add')} ${i18n.tc('tag', 1).toLowerCase()}`,
      dragInstructions: i18n.t('focusPointDragInstructions'),
      focusPointTitle: i18n.t('focusPointTitle'),
      focusPointDescription: i18n.t('focusPointDescription'),
      resetFocusPoint: i18n.t('resetFocusPoint'),
      typeLimitReached: type => i18n.tc('mediaTypeLimitReached', type.max, { type: type.name, max: type.max }),
      altTextLabel: i18n.t('altTextLabel'),
      altTextDescription: i18n.t('altTextDescription'),
      captionDescription: i18n.t('captionDescription'),
    },
  })

  FileSetup({
    upload,
    dropMessage: onFileDrop,
  })

  RichTextSetup({
    labels: {
      primary: i18n.t('primaryColor'),
      secondary: i18n.t('secondaryColor'),
      heading: i18n.t('richTextHeading2'),
      'heading-h2': i18n.t('richTextHeading2'),
      'heading-h3': i18n.t('richTextHeading3'),
      bold: i18n.t('richTextBold'),
      italic: i18n.t('richTextItalic'),
      superscript: i18n.t('richTextSuperscript'),
      orderedList: i18n.t('richTextNumberedList'),
      bulletList: i18n.t('richTextBulletList'),
      link: i18n.t('richTextAddLink'),
      button: i18n.t('createButton'),
      table: i18n.t('richTextInsertTable'),
      saveLink: i18n.t('save'),
      removeLink: i18n.t('richTextRemoveLink'),
      addColumnBefore: i18n.t('richTextInsertColumnLeft'),
      addColumnAfter: i18n.t('richTextInsertColumnRight'),
      deleteColumn: i18n.t('richTextDeleteColumn'),
      addRowBefore: i18n.t('richTextInsertRowAbove'),
      addRowAfter: i18n.t('richTextInsertRowBelow'),
      deleteRow: i18n.t('richTextDeleteRow'),
      mergeCells: i18n.t('richTextMergeCells'),
      splitCell: i18n.t('richTextSplitCell'),
      deleteTable: i18n.t('richTextDeleteTable'),
    },
  })

  StepperSetup({
    icons: {
      breadcrumb: ['fal', 'long-arrow-right'],
    },
  })
}
